import { render, staticRenderFns } from "./orderRouter.vue?vue&type=template&id=329c1316&scoped=true&"
import script from "./orderRouter.vue?vue&type=script&lang=js&"
export * from "./orderRouter.vue?vue&type=script&lang=js&"
import style0 from "./orderRouter.vue?vue&type=style&index=0&id=329c1316&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329c1316",
  null
  
)

export default component.exports